// assets/embla-loader.jsv=1.00
(function () {
    var w = window;
    if (w.EmblaCarousel) {
        w.__emblaPromise = w.__emblaPromise || Promise.resolve(w.EmblaCarousel);
        return;
    }
    if (w.__emblaPromise) return;

    var current = document.currentScript;
    var src = (current && current.dataset && current.dataset.emblaSrc) || '';

    w.__emblaPromise = new Promise(function (resolve, reject) {
        var existing = document.getElementById('embla-umd');
        if (existing) {
            if (w.EmblaCarousel) return resolve(w.EmblaCarousel);
            existing.addEventListener('load', function(){ resolve(w.EmblaCarousel); }, { once:true });
            existing.addEventListener('error', reject, { once:true });
            return;
        }
        if (!src) return reject(new Error('[Embla Loader] Missing data-embla-src'));
        var s = document.createElement('script');
        s.id = 'embla-umd';
        s.src = src;      // ← your local asset URL passed from Liquid
        s.defer = true;
        s.onload = function(){ resolve(w.EmblaCarousel); };
        s.onerror = function(){ reject(new Error('Failed to load Embla UMD: ' + src)); };
        document.head.appendChild(s);
    });
})();
